import React, {useContext} from "react";
import styles from './settings_submenu.module.css';
import {
    faBuilding,
    faHouse,
    faMoneyBill,
    faSliders,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link, useLocation} from "react-router-dom";
import MyContext from "../../../../Context";
import {useTranslation} from "react-i18next";

export default function SettingsSubmenu() {
    const {t} = useTranslation();
    const {user} = useContext(MyContext);
    const location = useLocation();

    const hasPermission = (module) => {
        if (!module) return true;
        if (user?.is_superuser) return true;
        if (!user?.role?.permissions) return true;
        const perm = user.role.permissions.find(p => p.module === module);
        return perm?.can_view ?? false;
    };

    const items = [
        {name: t('settings.submenu.general'), icon: faHouse, url: "/settings/general", module: null},
        {name: t('settings.submenu.members'), icon: faUsers, url: "/settings/users", module: 'users'},
        {name: t('settings.submenu.roles'), icon: faSliders, url: "/settings/roles", module: 'roles'},
        {name: t('settings.submenu.payments'), icon: faMoneyBill, url: "/settings/payments", module: 'payments'},
        {name: t('settings.submenu.companies'), icon: faBuilding, url: "/settings/companies", module: 'companies'}
    ].filter(item => hasPermission(item.module));

    return (
        <div className={`${styles.container} mt-3 mb-4`}>
            <div>
                <div className={styles.title}>{t('settings.submenu.configuration')}</div>

                <div className={`${styles.nav} mt-2`}>
                    {items.map((item, index) => {
                        const isActive = location.pathname === item.url;
                        return (
                            <Link to={item.url} key={index} className={`${styles.navItem} ${isActive ? styles.active : ""} d-flex align-items-center px-3 py-2`}>
                                <FontAwesomeIcon icon={item.icon} color={isActive ? "#4F46E5" : "#94A3B8"} className={'pe-1'}/>
                                <div className={styles.item}>{item.name}</div>
                            </Link>
                        );
                    })}
                    <div>

                    </div>
                </div>
            </div>
        </div>
    );
}